import ProductRergistration from "../pages/ProductRegistration";

const routes = {
  login: "/login",
  signUp: "/signup",
  resetPassword: "/reset-password",
  logout: "/logout",
  toppage: "/toppage",
  productRergistration: "/productRergistration",
  pendingReceipt: "/pendingReceipt",
  pendingPackaging: "/pendingPackaging",
  pendingPlan: "/pendingPlan",
  pendingShipment: "/pendingShipment",
  shipped: "/shipped",
  needsReview: "/needsReview",
  printLabel: "/printLabel",
  printLabels: "/printLabels",
  printExpirationLabels: "/printExpirationLabels",
  allList: "/allList",
  trustBox: "/trustBox",
  managementUsers: "/managementUsers",
  management: "/management",
  baseList: "/baseList",
  report: "/report",
  userInfo: "/userInfo",
  setting: "/setting",
  amazonCallbak: "/amazon/callback",
  operationLogs: "/operationLogs",
  privacy: "/privacy",
  terms: "/terms",
  notFound: "*",
};

export default routes;
